export const loanHistory = [
    {
        date: '2022-04-11',
        amountToPay: 20000,
        amountPaid: 5000,
        principal: 20000,
        interest_rate: 5,
        status: 'pending',
        applicants_name: 'Charles Kasasira',
        ID: '089375'
    },
    {
        date: '2022-04-12',
        amountToPay: 64000,
        amountPaid: 4000,
        principal: 100000,
        interest_rate: 4,
        status: 'paid',
        applicants_name: 'David Anyuru',
        ID: '059374'
    },
    {
        date: '2022-04-01',
        amountToPay: 20000,
        amountPaid: 5000,
        principal: 20000,
        interest_rate: 8,
        status: 'pending',
        applicants_name: 'Joanita Nakyito',
        ID: '11089374'
    },
    {
        date: '2021-06-02',
        amountToPay: 64000,
        amountPaid: 4000,
        principal: 100000,
        interest_rate: 5,
        status: 'due',
        applicants_name: 'Abudi Mutamba',
        ID: '343089234'
    }
]

export const depositHistory = [
    {
        date: '11-04-2022',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved'
    },
    {
        date: '11-04-2019',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Rejected'
    },
    {
        date: '11-04-2022',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved'
    },
    {
        date: '11-04-2019',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Pending'
    },
    {
        date: '11-04-2022',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved'
    },
    {
        date: '11-04-2019',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Rejected'
    },
    {
        date: '11-04-2022',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved'
    },
    {
        date: '11-04-2019',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Rejected'
    },
    {
        date: '11-04-2022',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved'
    },
    {
        date: '11-04-2019',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Pending'
    },
    {
        date: '11-04-2022',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved'
    },
    {
        date: '11-04-2019',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Rejected'
    },
    {
        date: '11-04-2022',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved'
    },
    {
        date: '11-04-2019',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Rejected'
    },
    {
        date: '11-04-2022',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved'
    },
    {
        date: '11-04-2019',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Pending'
    },
    {
        date: '11-04-2022',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved'
    },
    {
        date: '11-04-2019',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Rejected'
    },
]

export const withdrawHistory = [
    {
        date: '2022-04-11',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved',
        name: "Anyuru David Derrick"
    },
    {
        date: '2019-11-04',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Rejected',
        name: "Nakityo Joanita"
    },
    {
        date: '2022-11-04',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved',
        name: "Charles Kasasira"
    },
    {
        date: '201911-04',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Pending',
        name: "Charles Kasasira"
    },
    {
        date: '2022-11-04',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved',
        name: "Charles Kasasira"
    },
    {
        date: '2019-11-04',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Rejected',
        name: "Charles Kasasira"
    },
    {
        date: '2022-04-11',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved',
        name: "Anyuru David Derrick"
    },
    {
        date: '2019-11-04',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Rejected',
        name: "Nakityo Joanita"
    },
    {
        date: '2022-11-04',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved',
        name: "Charles Kasasira"
    },
    {
        date: '201911-04',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Pending',
        name: "Charles Kasasira"
    },
    {
        date: '2022-11-04',
        transactionId: 190012186,
        account: 'Savings',
        amount: 300000,
        depositMethod: 'Bank',
        status: 'Approved',
        name: "Charles Kasasira"
    },
    {
        date: '2019-11-04',
        transactionId: 190012067,
        account: 'Shares',
        amount: 180000,
        depositMethod: 'Bank',
        status: 'Rejected',
        name: "Charles Kasasira"
    },
]

export const memberApplications = [
    {
        date: '11-21-2021',
        name: 'Nakityo Joanita',
        id: 213103938,
        amount: 500000,
        status: 'Approved'
    },
    {
        date: '03-03-2022',
        name: 'Anyuru David',
        id: 213103938,
        amount: 300000,
        status: 'Pending'
    },
    {
        date: '01-04-2022',
        name: 'Kasasira Charles',
        id: 213103938,
        amount: 180000,
        status: 'Rejected'
    },
    {
        date: '11-21-2021',
        name: 'Nakityo Joanita',
        id: 213103938,
        amount: 500000,
        status: 'Approved'
    },
    {
        date: '03-03-2022',
        name: 'Anyuru David',
        id: 213103938,
        amount: 300000,
        status: 'Pending'
    },
    {
        date: '03-03-2022',
        name: 'Anyuru David',
        id: 213103938,
        amount: 300000,
        status: 'Pending'
    },
    {
        date: '03-03-2022',
        name: 'Anyuru David',
        id: 213103938,
        amount: 300000,
        status: 'Pending'
    },
    {
        date: '01-04-2022',
        name: 'Kasasira Charles',
        id: 213103938,
        amount: 180000,
        status: 'Rejected'
    },
    {
        date: '03-03-2022',
        name: 'Anyuru David',
        id: 213103938,
        amount: 300000,
        status: 'Pending'
    },
    {
        date: '01-04-2022',
        name: 'Kasasira Charles',
        id: 213103938,
        amount: 180000,
        status: 'Rejected'
    },
    {
        date: '01-04-2022',
        name: 'Kasasira Charles',
        id: 213103938,
        amount: 180000,
        status: 'Rejected'
    },
    {
        date: '03-03-2022',
        name: 'Anyuru David',
        id: 213103938,
        amount: 300000,
        status: 'Pending'
    },
    {
        date: '01-04-2022',
        name: 'Kasasira Charles',
        id: 213103938,
        amount: 180000,
        status: 'Rejected'
    },
]